import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ConfirmationComponent } from 'src/app/common/confirmation/confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
import { SharedService } from 'src/app/services/shared.service';
import { GlobalContants } from 'src/app/constants/global.contants';
import { environment } from 'src/environments/environment';
import { AlertService } from 'src/app/services/alert.service';
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
  selector: 'app-generate-api-key',
  templateUrl: './generate-api-key.component.html',
  standalone: true,
  imports: [MatBadgeModule, MatIconModule, MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TablerIconsModule,
  ],
})
export class GenerateApiKeyComponent implements OnInit {
  Key:any;
  company: any;
  token:string='';
  constructor(
    private dailog: MatDialog,
    private userService: UserService,
    private sharedService: SharedService,
    private alertService:AlertService,
    private clipboard: Clipboard
  ) { 
    this.getAPIKey();
    this.getToken();
  }

  copy(value:string) {
    this.alertService.success("Coppied!")
    this.clipboard.copy(value);
  }

  
  ngOnInit(): void { }

  /**
   * Get API key
   */
  getAPIKey(){
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    let company_id = userInfo?.company_details?.company_id;
    this.userService.getAPIKey(Number(company_id)).subscribe({
      next: (res: any) => {
        if (res.status == 200 && res.data[0]) {
          this.Key = res.data[0];
        }else{
          this.Key = null;
        }
      },
      error: (err) => {
        this.Key = null;
      }
    })
  } 

  /**
   * Get Token
   */
  getToken(){
    //logged in user token
    let token = this.sharedService.getStoreValue(GlobalContants.StoreKey.userToken)
    let body = {
      token : token,
      is_refresh : false
    };
    this.userService.updateToken(body).subscribe({
      next:((res:any)=>{
        if(res.status == 201){
          this.token = res.data;
        }else{
          this.token = '';
        }
      })
      ,error:(err)=>{
        this.token = '';
        this.alertService.error(err.error.message)
      }
    })
  }

  openDiilog(type:string='') {
      let message = 'Are you sure you want to reset the token?';
      if (!this.token) {
        message = 'Do you want to generate the token?';
      }     
      if (type == 'api_key') message = 'Are you sure you want to reset the api key?';

      this.dailog.open(ConfirmationComponent,
        {
          data: { message: message },
          width: '400px',
        })
        .afterClosed().subscribe((flag: boolean) => {
          if (flag && type == 'api_key') {
            this.updateApiKey();
          } else if (flag && type == 'token') {
            this.updateToken()
          }
        })
  }

  updateToken(){
    //logged in user token
    let token = this.sharedService.getStoreValue(GlobalContants.StoreKey.userToken)
    let body = {
      token : token,
      is_refresh : true
    };
    this.userService.updateToken(body).subscribe({
      next:((res:any)=>{
        if(res.status == 201){
          this.getToken();
          this.alertService.success(res.message)
        }else{
          this.alertService.warning(res.message)
        }
      })
      ,error:(err)=>{
        this.alertService.error(err.error.message)
      }
    })
  }
  /**
   * Update key
   */
  updateApiKey() {
    
   let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    var body = {
      key_id: this.Key?.key_id,
      company_id: userInfo?.company_details?.company_id,
      application_id: Number(environment.umsApp_id),
      updated_by: userInfo.user_id,
      place_id: this.Key?.place_id,
      is_update_token: true
    }
   
    this.userService.updateApiKey(body).subscribe({
      next:((res:any)=>{
        if(res.status == 201){
          this.getAPIKey();
          this.alertService.success(res.message)
        }else{
          this.alertService.warning(res.message)
        }
      })
      ,error:(err)=>{
        this.alertService.error(err.error.message)
      }
    })

  }
}
